const addOrRemoveAddOns = async (requestOption, productHandle, cartItems) => {
  try {
    const response = await fetch(`/products/${productHandle}.js`)
    const data = await response.json()
    cartItems.map((item) => {
      if (item.handle === productHandle) {
        data.variants.map((variant) => {
          if (variant.id === item.variant_id) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: `id=${variant.id}&quantity=0`,
            }).catch((error) => {
              console.error(error)
            })
          }
        })
      }
    })
  } catch (err) {
    console.log(err)
  }
}
const removeVariantByHandle = async (productHandle, cartItems) => {
  try {
    const response = await fetch(`/products/${productHandle}.js`)
    const data = await response.json()
    cartItems.map((item) => {
      if (item.handle === productHandle) {
        data.variants.map((variant) => {
          if (variant.id === item.variant_id) {
            jQuery.ajax({
              type: "POST",
              url: `/cart/change?id=${variant.id}&quantity=0`,
              dataType: "json",
            })
          }
        })
      }
    })
  } catch (err) {
    console.log(err)
  }
}
const removeSubBtnFG = () => {
  const itemInfoContainer = document.querySelectorAll(
    ".rebuy-cart__flyout-item-info"
  )
  itemInfoContainer.forEach((item) => {
    const freeGiftLabel = item.querySelector(
      ".rebuy-cart__flyout-item-discount-message"
    )
    if (freeGiftLabel) {
      item.classList.add("is-gift")
    } else {
      item.classList.remove("is-gift")
    }
  })
}
document.addEventListener("rebuy.productsChange", function (event) {
  if (event.detail.widget.id === "166223") {
    const requestOption =
      event.detail.widget.data.metadata?.custom?.request_option
    const productHandle =
      event.detail.widget.data.metadata?.custom?.product_handle
    const cartItems = event.detail.widget.data.cart.items
    if (productHandle) {
      addOrRemoveAddOns(requestOption, productHandle, cartItems)
    }
  }
  if (["166223"].includes(event.detail.widget.id)) {
    const removeProductHandle =
      event.detail.widget.data.metadata?.custom?.remove_product
    const cartItems = event.detail.widget.data.cart.items
    if (removeProductHandle) {
      removeVariantByHandle(removeProductHandle, cartItems)
    }
  }
})
document.addEventListener("rebuy:cart.change", (event) => {
  setTimeout(() => {
    removeSubBtnFG()
  }, 1000)
  const cartCount = document.querySelectorAll("[data-cart-count]")
  cartCount.forEach((el) => (el.innerText = event.detail.cart.cart.item_count))
})
document.addEventListener("rebuy:smartcart.ready", () => {
  removeSubBtnFG()
})

const addWidthHeightToImage = (widget, width, height) => {
  const container = document.querySelector(`#rebuy-widget-${widget.id}`)
  if (!container) return
  const images = container.querySelectorAll(".rebuy-product-image img")
  images.forEach((image) => {
    image.setAttribute("width", width)
    image.setAttribute("height", height)
  })
}
